"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withSetRealmAuthority = void 0;
var web3_js_1 = require("@solana/web3.js");
var serialisation_1 = require("./serialisation");
var borsh_1 = require("borsh");
var instructions_1 = require("./instructions");
var registry_1 = require("../registry");
var withSetRealmAuthority = function (instructions, programId, programVersion, realm, realmAuthority, newRealmAuthority, action) {
    var args = new instructions_1.SetRealmAuthorityArgs({
        newRealmAuthority: newRealmAuthority,
        action: action, // V2
    });
    var data = Buffer.from((0, borsh_1.serialize)((0, serialisation_1.getGovernanceInstructionSchema)(programVersion), args));
    var keys = [
        {
            pubkey: realm,
            isWritable: true,
            isSigner: false,
        },
        {
            pubkey: realmAuthority,
            isWritable: false,
            isSigner: true,
        },
    ];
    if (programVersion > registry_1.PROGRAM_VERSION_V1) {
        keys.push({
            pubkey: newRealmAuthority,
            isWritable: false,
            isSigner: false,
        });
    }
    instructions.push(new web3_js_1.TransactionInstruction({
        keys: keys,
        programId: programId,
        data: data,
    }));
};
exports.withSetRealmAuthority = withSetRealmAuthority;
//# sourceMappingURL=withSetRealmAuthority.js.map